import { BaseAPI } from './BaseAPI.js'
import { JSONApiResponse } from '../interfaces/JSONApi.js'
import { Dashboard, PreparedQueryConfig } from '../types/index.js'

interface QueryResult {
  rowCount: number
  data: Array<any>
  columns: { [column: string]: string }
}

interface QueryError {
  error: string
}
export default class DashboardsAPI extends BaseAPI<Dashboard> {
  override get resource(): string {
    return '/dashboards'
  }

  async dashboardResultSets(
    id: number | string,
    variables: { [key: string]: unknown } = {},
  ): Promise<{
    resultSets: {
      panels: { [panelId: string]: any }
      variables: { [panelId: string]: any }
    }
    meta: object
  }> {
    return (
      await this._client.get(`dashboards/${id}/resultSets`, {
        params: variables,
      })
    ).data
  }

  async runQuery(
    item: any,
    variables: { [key: string]: unknown } = {},
  ): Promise<QueryResult & QueryError> {
    return (
      await this._client.post(`dashboards/query`, item, { params: variables })
    ).data
  }

  async runPreparedQuery(
    query: PreparedQueryConfig,
    variables: { [key: string]: unknown } = {},
  ): Promise<QueryResult & QueryError> {
    return (
      await this._client.post(
        `dashboards/preparedQuery`,
        { data: query },
        { params: variables },
      )
    ).data
  }

  async exportToCsv(
    item: any,
    variables: { [key: string]: unknown } = {},
  ): Promise<QueryResult & QueryError> {
    return (
      await this._client.post(`/dashboards/exportToCsv`, item, {
        params: variables,
      })
    ).data
  }

  public async uploadConfig(
    organizationId: any,
    file: any,
  ): Promise<JSONApiResponse<Dashboard>> {
    const formData = new FormData()

    formData.append('import_file', file)
    formData.append('organizationId', organizationId)
    const fileUploadResponse = await this._client.post(
      `${this.resource}/config`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return fileUploadResponse.data
  }
}
